import { useEffect, useState } from "react";
// 게시판 읽기 API (../homepage_backend). npm start / npm run build 모두 기본은 운영 주소.
// 로컬 백엔드로 바꾸려면 REACT_APP_API_URL=http://localhost:3001 npm start (또는 .env.development.local 에 같은 줄)
const API = process.env.REACT_APP_API_URL || "https://api.aonecustoms.com/homepage-api";
const cache = {};
const get = url => cache[url] || (cache[url] = fetch(API + url)
  .then(r => (r.ok ? r.json() : Promise.reject(new Error(r.status))))
  .catch(e => { delete cache[url]; throw e; }));

// 목록 [{no, title, subtitle, date, author, article_type}] (no 내림차순). 실패/로딩 중엔 []
export const useArticles = category => {
  const [list, setList] = useState([]);
  useEffect(() => { get(`/articles?category=${category}`).then(setList).catch(() => setList([])); }, [category]);
  return list;
};

// 오늘의 브리핑 [{section, source, title, url, date}] 날짜 내림차순, 섹션·출처별 최신 5건 (백엔드 crawl.js 가 평일 새벽 수집). 실패/로딩 중엔 []
export const useBriefing = () => {
  const [list, setList] = useState([]);
  useEffect(() => { get("/briefing").then(setList).catch(() => setList([])); }, []);
  return list;
};

// undefined: 로딩, null: 없음, 객체: {no, title, subtitle, date, content, ref_url, author, article_type, attached: [{filename, url}]}
export const useArticle = (category, no) => {
  const [article, setArticle] = useState();
  useEffect(() => {
    setArticle(undefined);
    get(`/articles/${category}/${no}`).then(setArticle).catch(() => setArticle(null));
  }, [category, no]);
  return article;
};
